import _ from 'lodash';
import moment from 'moment';
import { START_OF_DAY, END_OF_DAY } from '../../../../lib/constants/constants';

const { formatDatePeristTimeZone, convertTimeTo12HoursFormat } = require('../../../../lib/bputils').default;

const getHoursForToday = (hoursByDay) => {
  const todayDayNumber = formatDatePeristTimeZone(moment(), 'E');
  return hoursByDay[todayDayNumber];
};

const computeClosingHour = (stationHours) => {
  const openingHoursString = stationHours?.opening_hours || '';
  const hoursByDay = stationHours?.hours_by_day || {};

  let closingHours;
  if (!openingHoursString) {
    closingHours = 'Add station hours';
  } else if (openingHoursString === '24/7') {
    closingHours = 'Station is open 24/7';
  } else if (Object.keys(hoursByDay).length === 0) {
    closingHours = 'Station is closed';
  } else {
    const todayHours = getHoursForToday(hoursByDay);
    if (!todayHours) {
      closingHours = 'Station is closed today';
    } else if (todayHours.open === START_OF_DAY && todayHours.close === END_OF_DAY) {
      closingHours = 'Station is open 24 hours today';
    } else {
      let nextDay = '';
      if (Number(todayHours.open.replace(':', '')) > Number(todayHours.close.replace(':', ''))) {
        nextDay = ' (next day)';
      }
      closingHours = `Open today until ${convertTimeTo12HoursFormat(todayHours.close)}${nextDay} local time`;
    }
  }

  return closingHours;
};

const mapEmergencyStatusesToObject = (emergencyStatus) => {
  const emergencyStatusKeyBy = _.keyBy(emergencyStatus, 'id');
  return {
    has_power: !!emergencyStatusKeyBy.has_power,
    has_gas: !!emergencyStatusKeyBy.has_gas,
    has_diesel: !!emergencyStatusKeyBy.has_diesel,
  };
};

const getStatusDisplayName = (openStatus) => {
  switch (openStatus) {
    case 'closed':
      return 'Temporarily Closed';
    case 'closed_permanently':
      return 'Permanently Closed';
    case 'open':
      return 'Open for Business';
    default:
      return undefined;
  }
};

export {
  computeClosingHour,
  mapEmergencyStatusesToObject,
  getStatusDisplayName,
};
